import axios from "axios";
import { apiVariable } from "./apiVariable";
import {
  EquipmentInventoryList,
  EquipmentItem,
  IssueInventoryList,
  SaveEquipmentItem,
} from "../interfaces/Fleet/EquipmentInventory";

const endpoint = `${apiVariable}/equipment-inventory`;
const config = (token?: string | null) => ({
  headers: { Authorization: `Bearer ${token}` },
});

export const equipmentInventoryService = {
  getEquipment: async (token?: string | null) =>
    (await axios.get<EquipmentItem[]>(`${endpoint}/equipment`, config(token)))
      .data,
  createEquipment: async (
    token: string | null | undefined,
    item: SaveEquipmentItem,
  ) =>
    (
      await axios.post<EquipmentItem>(
        `${endpoint}/equipment`,
        item,
        config(token),
      )
    ).data,
  updateEquipment: async (
    token: string | null | undefined,
    id: string,
    item: SaveEquipmentItem,
  ) =>
    (
      await axios.put<EquipmentItem>(
        `${endpoint}/equipment/${id}`,
        item,
        config(token),
      )
    ).data,
  getLists: async (token?: string | null, driverId?: string) =>
    (
      await axios.get<EquipmentInventoryList[]>(`${endpoint}/lists`, {
        ...config(token),
        params: driverId ? { driverId } : undefined,
      })
    ).data,
  issue: async (
    token: string | null | undefined,
    payload: IssueInventoryList,
  ) =>
    (
      await axios.post<EquipmentInventoryList>(
        `${endpoint}/lists`,
        payload,
        config(token),
      )
    ).data,
  returnItems: async (
    token: string | null | undefined,
    id: string,
    items: Array<{ inventoryListItemId: string; quantityReceived: number }>,
  ) =>
    (
      await axios.post<EquipmentInventoryList>(
        `${endpoint}/lists/${id}/returns`,
        { items },
        config(token),
      )
    ).data,
  downloadPdf: async (token: string | null | undefined, id: string) => {
    const response = await axios.get(`${endpoint}/lists/${id}/pdf`, {
      ...config(token),
      responseType: "blob",
    });
    const url = URL.createObjectURL(response.data);
    const link = document.createElement("a");
    link.href = url;
    link.download = `equipment-inventory-${id}.pdf`;
    link.click();
    URL.revokeObjectURL(url);
  },
};
